import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ActiveObject, resolve } from '../../Container';
import { EditorModeInfo } from '../EditorModeInfo';
import { EditorSession } from '../EditorSession';
import { MyRoleInfo } from '../MyRoleInfo';
import { timeMachine } from '../replay/ReplayCommands';
import { ViewMode } from '../workflow/ViewMode';
import { WidgetManager } from '../workspace/widgets/WidgetManager';
import { redo, undo } from './HistoryCommands';

export class HistoryMechanics extends ActiveObject {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(EditorSession) private session!: EditorSession;
    @resolve(WidgetManager) private widgets!: WidgetManager;

    public start(): void {
        this.burden(
            this.session.observe(MyRoleInfo, this.realizeHistoryWidgetsIfApplicable),
            this.session.observe(EditorModeInfo, this.realizeHistoryWidgetsIfApplicable),
        );
        this.realizeHistoryWidgetsIfApplicable();
    }

    private realizeHistoryWidgetsIfApplicable = () => {
        const { dispatch, session, widgets } = this;
        const { canParticipate } = session.get(MyRoleInfo);
        const mode = session.get(EditorModeInfo);

        widgets.delete('history');
        widgets.delete('replay');

        if (!canParticipate) return;
        if (mode.id === ViewMode.id) return;

        const history = widgets.createContainer();
        history.name = 'history';
        history.weight = 200;
        history.style = 'floatWithLines';
        history.position = ['docked', 'bottomLeft', 'inline'];

        // Undo
        history.add(widgets.createButton({
            image: 'deqo://icons/sln/12-design/rotate-back',
            text: 'Undo',
            onAction: () => dispatch(undo)
        }));

        // Redo
        history.add(widgets.createButton({
            image: 'deqo://icons/sln/12-design/rotate-forward',
            text: 'Redo',
            onAction: () => dispatch(redo)
        }));

        const replay = widgets.createContainer({
            name: 'replay',
            weight: 300,
            style: 'floatWithLines',
            position: ['docked', 'bottomLeft', 'inline'],
        });

        // The button
        replay.add(widgets.createButton({
            name: 'timeMachine',
            text: 'Time Machine',
            image: 'deqo://icons/i8/history',
            onAction() {
                dispatch(timeMachine);
            }
        }));

        widgets.add(history);
        widgets.add(replay);
    };
}
